<template>
  <div>
    <input type="radio" id="0" value="mean" v-model="picked" />
    <label for="mean">Mean</label>
    <br />
    <input type="radio" id="1" value="median" v-model="picked" />
    <label for="median">Median</label>
    <br />
    <input type="radio" id="2" value="mode" v-model="picked" />
    <label for="mode">Mode</label>
    <br />
    <input type="radio" id="3" value="sdev" v-model="picked" />
    <label for="sdev">Standard Dev</label>
    <br />
    <span>Picked: {{ picked }}</span>
  </div>
</template>

<script>
import { constants } from "crypto";
export default {
  props: ["emitter", "ikey", "getData", "putData"],
  data() {
    return {
      picked: "mean"
    };
  },
  methods: {
    update(newVal, oldVal) {
      if (this.ikey) {
        this.putData(this.ikey, this.picked);
      }
      if (this.emitter !== undefined) this.emitter.trigger("process");
    }
  },
  watch: {
    picked: function(newVal, oldVal) {
      this.update(newVal, oldVal);
    }
  },
  mounted() {
    if (this.getData !== undefined) {
      this.picked = this.getData(this.ikey);
     // console.log("getData key=" + this.ikey + " value=" + this.picked);
    }
  }
};
</script>

<style>
</style>
